import React from 'react';
import { Infographic } from './components/Infographic';
import { GoogleAnalytics } from './components/GoogleAnalytics';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="flex flex-col w-full min-h-full bg-gradient-to-b from-blue-50 to-white" data-id="element-0">
      <GoogleAnalytics data-id="element-1" />
      <MetaPixel data-id="element-2" />
      <Infographic data-id="element-3" />
      <footer className="w-full py-6 bg-gray-50 mt-16" data-id="element-4">
        <div className="max-w-4xl mx-auto px-4 text-center text-gray-500 text-sm" data-id="element-5">
          <p data-id="element-6">© 2023 iRelief. All rights reserved.</p>
          <p className="mt-2" data-id="element-7">
            This content is for informational purposes only and is not intended
            to be a substitute for professional medical advice, diagnosis, or
            treatment.
          </p>
        </div>
      </footer>
    </div>;
}